import { Switch } from '@material-ui/core';
import * as React from "react";

interface IFIASwitchProps {
    onChange: (e: any, c: boolean) => void
    checked: boolean
    color?: any
    style?: any
    classes?:any
}
export default class FIASwitch extends React.Component<IFIASwitchProps> {
    public render(): JSX.Element {
        return (
            <Switch
                {...this.props}
            />
        )
    }
}


// WEBPACK FOOTER //
// ./src/app/abstract/Views/Switch.tsx